module.exports = __webpack_public_path__ + "img/black-eye.2e48fdf2.svg";